import { Component, Input, OnInit } from '@angular/core';
import { ConversionService } from '../../services/ConversionService';
import { UnitObject } from '../../models/UnitObject';
import { Unit } from '../../models/Enums';
import { MFGDBColumn } from '../../models/MFGDBColumn';

@Component({
  selector: 'app-datavalue',
  templateUrl: './datavalue.component.html',
  styleUrl: './datavalue.component.css'
})
export class DatavalueComponent implements OnInit {
  @Input() DataColumn: MFGDBColumn;
  @Input() InitialValue: string;
  @Input() InitialUnit: Unit;
  @Input() AllowConversion: boolean;
  @Input() MeasureUnit: string;
  DisplayValue: string;
  DisplayUnit: UnitObject;
  SourceUnit: UnitObject;
  AvailableUnits: UnitObject[];
  ngOnInit() {
    this.AvailableUnits = this.convServer.GetAvailableUnits(this.DataColumn.DBColumnName);
    this.DisplayUnit = new UnitObject(this.DataColumn.CustomText, this.convServer.GetUnitFromString(this.DataColumn.DefaultUOM), this.convServer);
    this.SourceUnit = new UnitObject(this.convServer.GetUnitDisplayText(this.InitialUnit), this.InitialUnit, this.convServer);

    if (this.DataColumn.DefaultUOM != "" && this.DataColumn.DBColumn.DefaultUOM != this.DataColumn.DefaultUOM) {
      this.InitialValue = this.convServer.ConvertValue(parseFloat(this.InitialValue), new UnitObject(this.DataColumn.DBColumn.DisplayText, this.convServer.GetUnitFromString(this.DataColumn.DBColumn.DefaultUOM), this.convServer), new UnitObject(this.DataColumn.CustomText, this.convServer.GetUnitFromString(this.DataColumn.DefaultUOM), this.convServer)).toString().substring(0,8);
    }

    this.DisplayValue = this.InitialValue;


    if (this.AvailableUnits.length <= 1) {
      this.AllowConversion = false;
    }
    else {
      this.AllowConversion = true;
    }
  }

  public constructor(private convServer: ConversionService) {
    this.InitialValue = "";
    this.InitialUnit = 0;
    this.MeasureUnit = ""
    this.DataColumn = new MFGDBColumn();
    this.DisplayUnit = new UnitObject(this.convServer.GetUnitDisplayText(this.InitialUnit), this.InitialUnit, this.convServer);
    this.SourceUnit = new UnitObject(this.convServer.GetUnitDisplayText(this.InitialUnit), this.InitialUnit, this.convServer);
    this.DisplayValue = this.InitialValue;
    this.AvailableUnits = [];
    this.AllowConversion = false;
  }

  UnitChanged(event: any) {

    this.DisplayValue = this.convServer.ConvertValue(parseFloat(this.DisplayValue), this.SourceUnit, this.DisplayUnit).toFixed(8);
    this.SourceUnit = this.DisplayUnit;
  }

  GetUnitDisplayUOM(unitObj: UnitObject) {
    if (this.DataColumn == undefined || this.DataColumn.UnitDisplay == "") {
      return this.convServer.GetUnitDisplayText(unitObj.Unit);
    }
    else {
      return this.DataColumn.UnitDisplay;
    }
  }

  customCompareUnit(a: UnitObject, b: UnitObject) {
    return a.Unit == b.Unit;
  }
}
